import React, { useEffect, useState } from 'react';
import { ArrowRight, Cpu, Database, Github, User } from 'lucide-react';

const deploySnippets = [
  {
    id: 'github',
    title: 'Git Repository',
    command: '$ devorants deploy --repo github.com/user/app',
    logs: [
      '[1/4] Cloning repository...',
      '[2/4] Detecting framework (Node.js)...',
      '[3/4] Building Docker image...',
      '[4/4] Allocating port and routing...',
    ],
  },
  {
    id: 'dockerhub',
    title: 'Docker Hub Image',
    command: '$ devorants deploy --image redis:alpine',
    logs: [
      '[1/3] Pulling image from Docker Hub...',
      '[2/3] Extracting layers...',
      '[3/3] Configuring internal network...',
    ],
  },
  {
    id: 'compose',
    title: 'Docker Compose',
    command: '$ devorants deploy --compose ./docker-compose.yml',
    logs: [
      '[1/4] Parsing docker-compose.yml...',
      '[2/4] Creating network...',
      '[3/4] Starting db (postgres:15)...',
      '[4/4] Starting web (node:18)...',
    ],
  },
];

const LandingHero = ({ user, onLoginClick, onDashboardClick }) => {
  const [index, setIndex] = useState(0);
  const current = deploySnippets[index];

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % deploySnippets.length);
    }, 4200);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="lp-hero">
      <div className="lp-hero-glow" aria-hidden="true" />
      <div className="lp-container lp-hero-grid">
        <div className="lp-hero-copy">
          <span className="lp-badge lp-badge-soft">
            Getting your ideas live in a few clicks
          </span>
          <h1 className="lp-hero-title">
            Deploy your ideas.
            <br />
            We&apos;ll handle <span>the servers.</span>
          </h1>
          <p className="lp-hero-subtitle">
            Seamlessly ship Docker, Git, and ZIP deployments with auto-generated
            routing, instant rollbacks, and team collaboration built in.
          </p>
          <div className="lp-hero-actions">
            {user ? (
              <button type="button" className="lp-btn lp-btn-primary lp-btn-lg" onClick={onDashboardClick}>
                Go to Dashboard
                <ArrowRight size={18} />
              </button>
            ) : (
              <button type="button" className="lp-btn lp-btn-primary lp-btn-lg" onClick={() => onLoginClick('hobby')}>
                Get started for free
                <ArrowRight size={18} />
              </button>
            )}
            <button type="button" className="lp-btn lp-btn-secondary lp-btn-lg" onClick={(e) => e.preventDefault()}>
              Read the docs
            </button>
          </div>
          <div className="lp-hero-stats">
            <div>
              <strong>9+</strong>
              <span>Deploy methods</span>
            </div>
            <div>
              <strong>12 GB</strong>
              <span>Max upload size</span>
            </div>
            <div>
              <strong>~30s</strong>
              <span>Avg deploy time</span>
            </div>
          </div>
        </div>

        <div className="lp-hero-visual">
          <div className="lp-float-card lp-float-user">
            <span className="lp-avatar"><User size={14} /></span>
            <div>
              <strong>Jane Doe</strong>
              <span>Pushed to main</span>
            </div>
            <Github size={14} />
          </div>

          <div className="lp-float-chip lp-float-resize">
            <Cpu size={13} />
            Resize
          </div>

          <div className="lp-float-chip lp-float-cpu">
            <Database size={13} />
            CPU-optimized
          </div>

          <div className="lp-terminal" key={current.id}>
            <div className="lp-terminal-bar">
              <span className="dot r" />
              <span className="dot y" />
              <span className="dot g" />
              <span className="lp-terminal-title">bash — {current.title}</span>
            </div>
            <div className="lp-terminal-body">
              <div className="lp-terminal-line cmd">{current.command}</div>
              {current.logs.map((log, i) => (
                <div
                  key={log}
                  className="lp-terminal-line muted"
                  style={{ animationDelay: `${(i + 1) * 0.12}s` }}
                >
                  {log}
                </div>
              ))}
              <div
                className="lp-terminal-line success"
                style={{ animationDelay: `${(current.logs.length + 1) * 0.12}s` }}
              >
                ✓ Deployment successful!
              </div>
              <div
                className="lp-terminal-line"
                style={{ animationDelay: `${(current.logs.length + 1.5) * 0.12}s` }}
              >
                URL: <span className="link">https://myapp.devorants.io</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingHero;
